import { ActivityEnrollableTimesModal_ActivityFragment } from "@outschool/gql-frontend-generated";

export const hasOneOnOneAvailabilities = (
  activityWithEnrollableTimes?: ActivityEnrollableTimesModal_ActivityFragment
) => {
  return !!activityWithEnrollableTimes?.enrollableTimes.length;
};
